<div class="main-card shadow-sm h-100">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faFileInvoiceDollar" style="font-size: 14px; color: #00305C;"></fa-icon>
      <span class="main-heading fw-smbold">Expenses</span>
    </div>
    @if (expensesList.length > 5) {
      <button class="btn view-all-btn d-flex align-items-center gap-1"
        (click)="viewAllExpenses()">
        View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
      </button>
    }
  </div>
  <!-- Highlight Cards -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <div class="highlight-card h-100">
        <div class="highlight-heading mb-1">Total Entries</div>
        <div class="blue-value fw-bold">{{ totalEntries | number }}</div>
        <span class="footer-label"> {{changeValue}}</span>
      </div>
    </div>
    <div class="col-6">
      <div class="highlight-card h-100">
        <div class="highlight-heading mb-1">Total Amount</div>
        <div class="red-value fw-bold">{{ totalAmount | number }}</div>
        <span class="footer-label">Avg ₹{{avgPerTyre}}/entry</span>
      </div>
    </div>
  </div>
  <!-- Table -->
  <div class="table-box">
    <table class="table custom-table border-0 mb-0">
      <thead>
        <tr>
          <th class="fw-smbold border-0">Category</th>
          <th class="fw-smbold border-0">Branch</th>
          <th class="text-end fw-smbold border-0">Count</th>
          <th class="text-end fw-smbold border-0">Amount</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
          <tr>
            <td colspan="4" class="text-center py-4 border-0">
              <app-loader [loadingIcon]="loader"></app-loader>
            </td>
          </tr>
        }
        <!-- Error State -->
        @if (!loader && errMsg) {
          <tr>
            <td colspan="4" class="text-center py-4 border-0">
              <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
            </td>
          </tr>
        }
        <!-- Data State -->
        @if (!loader && !errMsg) {
          @for (item of expensesList | slice:0:5; track item) {
            <tr (click)="onRowClick(item)" class="cursor-pointer">
              <td class="col-1-text border-0">{{ item.categoryName }}</td>
              <td class="col-1-text border-0">{{ item.companyName }}</td>
              <td class="text-end col-2-text fw-smbold border-0">
                @if (item.count !== null) {
                  {{ item.count | number }}
                } @else {
                  -
                }
              </td>
              <td class="text-end col-3-text fw-bold border-0">
                @if (item.amount !== null) {
                  {{ item.amount | number }}
                } @else {
                  -
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
<!-- Modal Template -->
<ng-template #expensesModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">All Expenses</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1">
      <table class="table custom-table border-0 mb-0">
        <thead>
          <tr>
            <th class="fw-smbold border-0">Category</th>
            <th class="fw-smbold border-0">Branch</th>
            <th class="text-end fw-smbold border-0">Count</th>
            <th class="fw-smbold border-0 text-center">Payment Type</th>
            <th class="fw-smbold border-0 text-center">Payment Account</th>
            <th class="text-end fw-smbold border-0">Amount</th>
          </tr>
        </thead>
        <tbody>
          @if (expensesList.length > 0) {
            @for (item of expensesList; track item) {
              <tr (click)="onRowClick(item)" class="cursor-pointer">
                <td class="col-1-text border-0">{{ item.categoryName }}</td>
                <td class="col-1-text border-0">{{ item.companyName }}</td>
                <td class="text-end col-2-text fw-smbold border-0">
                  @if (item.count !== null) {
                    {{ item.count | number }}
                  } @else {
                    -
                  }
                </td>
                <td class="col-1-text border-0 text-center">{{ item.paymentMode || '-' }}</td>
                <td class="col-1-text border-0 text-center">{{ item.accountName || '-'}}</td>
                <td class="text-end col-3-text fw-bold border-0">
                  @if (item.amount !== null) {
                    {{ item.amount | number }}
                  } @else {
                    -
                  }
                </td>
              </tr>
            }
          }
          @if (expensesList.length === 0) {
            <tr>
              <td colspan="6" class="text-center py-4 border-0">
                <p class="text-muted mb-0 small fw-bold">No expenses data found.</p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #detailedExpensesModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">Expense Details</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1"
         infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
         [infiniteScrollThrottle]="500" (scrolled)="onScrollDetail()"
         style="max-height: 60vh; overflow-y: auto;">
      <table class="table custom-table border-0 mb-0">
        <thead>
          <tr>
            <th class="fw-smbold border-0">Date</th>
            <th class="fw-smbold border-0">Exp ID</th>
            <th class="fw-smbold border-0">Notes</th>
            <th class="fw-smbold border-0">Category</th>
            <th class="fw-smbold border-0">Branch</th>
            <th class="text-end fw-smbold border-0">Amount</th>
          </tr>
        </thead>
        <tbody>
          <!-- Initial Loader State -->
          @if (detailLoader && detailedExpensesList.length === 0) {
            <tr>
              <td colspan="6" class="text-center py-5 border-0">
                <app-loader [loadingIcon]="detailLoader"></app-loader>
              </td>
            </tr>
          }
          <!-- Error State -->
          @if (!detailLoader && detailErrMsg) {
            <tr>
              <td colspan="6" class="text-center py-4 border-0">
                <p class="text-danger mb-0 small fw-bold">{{ detailErrMsg }}</p>
              </td>
            </tr>
          }
          <!-- Data State -->
          @if (!detailErrMsg) {
            @if (detailedExpensesList.length > 0) {
              @for (item of detailedExpensesList; track item._id) {
                <tr>
                  <td class="col-1-text border-0">{{ item.transactionDate | date:'dd-MM-yyyy':'Asia/Kolkata' }}</td>
                  <td class="col-1-text border-0">{{ item.expId }}</td>
                  <td class="col-2-text border-0">
                    <div>{{ item.description || item.notes || '-' }}</div>
                    @if (item.paymentMode) {
                      <small class="text-muted" style="font-size: 10px;">
                        {{ item.paymentMode }}
                        @if (item.paymentAccount?.accountName) {
                          &middot; {{ item.paymentAccount.accountName }}
                        }
                      </small>
                    }
                  </td>
                  <td class="col-2-text border-0">{{ item.category?.name || item.categoryName || '-' }}</td>
                  <td class="col-1-text border-0">{{ item.company?.name || item.branchName || '-' }}</td>
                  <td class="text-end col-3-text fw-bold border-0">
                    @if (item.amount !== null) {
                      ₹{{ item.amount | number }}
                    } @else {
                      -
                    }
                  </td>
                </tr>
              }
              <!-- Load More Spinner -->
              @if (detailLoader && detailedExpensesList.length > 0) {
                <tr>
                  <td colspan="6" class="text-center py-3 border-0">
                    <output class="spinner-border spinner-border-sm text-primary"></output>
                  </td>
                </tr>
              }
            } @else if (!detailLoader) {
              <tr>
                <td colspan="6" class="text-center py-4 border-0">
                  <p class="text-muted mb-0 small fw-bold">No expenses found.</p>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
